<template>
        <v-container>
            <v-row class="contentRow">
                <v-col>
                    <h1 class="mb-2">Orixe Audit</h1>
                </v-col>
            </v-row>
            <v-row class="contentRow" align="center">
                <v-col cols="12" style="align-self: baseline" class="flex-grow-0">
                    <v-menu offset-y  >
                        <template v-slot:activator="{ on, attrs }">
                            <v-chip
                                    label
                                    color="primary"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                            >
                                <span>Last <b>{{selectedDayCount}}</b> days</span>
                            </v-chip>
                        </template>
                        <v-list>
                            <v-list-item-group @change="dayChange" >
                                <v-list-item
                                        v-for="(item, index) in items"
                                        :key="index"
                                        :value="item"
                                >
                                    <v-list-item-title>{{ item }}</v-list-item-title>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-menu><br />
                </v-col>
                <v-col cols="6">
                    <v-simple-table style="background: #e8e8e8" >
                        <template v-slot:default>
                            <tbody>
                            <tr>
                                <td>
                                    Audits requests sent last
                                    <strong>
                                       {{selectedDayCount}}
                                    </strong>
                                    days
                                </td>
                                <td>{{auditRequestsSent}}</td>
                            </tr>
                            <tr>
                                <td>
                                    Audits requests completed
                                    <strong>
                                        {{selectedDayCount}}
                                    </strong>
                                    days
                                </td>
                                <td>{{auditRequestsCompleted}}</td>
                            </tr>
                            <tr>
                                <td>
                                    Audits requests Assessed
                                    <strong>
                                        {{selectedDayCount}}
                                    </strong>
                                    days
                                </td>
                                <td>{{auditRequestsAssessed}}</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
                <v-col cols="6" style="align-self: baseline">
                    <v-simple-table style="background: #e8e8e8" >
                        <template v-slot:default>
                            <tbody>
                            <tr>
                                <td>
                                    Audits requests received last
                                    <strong>
                                        {{selectedDayCount}}
                                    </strong>
                                    days
                                </td>
                                <td>{{auditRequestsReceived}}</td>
                            </tr>
                            <tr>
                                <td>
                                    Audits requests completed last
                                    <strong>
                                        {{selectedDayCount}}
                                    </strong>
                                    days
                                </td>
                                <td>{{auditRequestsCompleted}}</td>
                            </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row class="contentRow" align="center">
                <v-col cols="12">
                    <h3 class="center">Audits sent to suppliers</h3>
                    <AuditLineChart/>
                </v-col>
                <v-col cols="6" v-if="blockOptions.data.length>0">
                    <v-card color="primary" >
                        <v-card-title class="text-center justify-left py-6">
                            <h3 class="white--text">Most Recent Blocks</h3>
                        </v-card-title>
                        <v-data-table
                                theme--
                                light
                                :headers="headers"
                                :items="blockOptions.data"
                                :items-per-page="blockOptions.limit"
                                :options.sync="blockOptions.options"
                                class="light table mx-4 assessed-table data-table"
								:footer-props="{
						'items-per-page-options': [5, 10, 15]
					}"
                        >
                            <template v-slot:item.Index="{ item }">
                                <a :href="'http://nodes.orixe.tech/blocks/' + item.Index" target="_blank">{{item.Index}}</a>
                            </template>
                            <template v-slot:item.Timestamp="{ item }">
                                {{item.Timestamp}}
                            </template>
                        </v-data-table>
                        <br/>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
</template>


<script>
import AuditLineChart from "../../components/AuditLineChart"
import BlockAPI from "../../api/trace/block"
import LoadingState from "../../consts/LoadingState"
import AuditsAPI from "../../api/audit/audit"
import AuditRequestsAPI from "../../api/audit/request"
export default {
	name: "AuditDashboard",
	components:{
		AuditLineChart
	},
	data() {
		return {
			auditRequestsSent:null,
			auditRequestsAssessed:null,
			auditRequestsReceived:null,
			auditRequestsCompleted:null,
			selectedDayCount:30,
			blockOptions:{
				data:[],
				loading:true,
				limit:5,
			},
			headers: [
				{
					text: "Block Index",
					align: "start",
					sortable: false,
					value: "Index",
					class: "secondary--text"
				},
				{
					text: "Timestamp",
					value: "Timestamp",
					sortable: false,
					class: "secondary--text"
				},
				{
					text: "Size",
					value: "Size",
					sortable: false,
					class: "secondary--text"
				},
			],
			items: [30,60,90,180]
		}
	},
	mounted() {
		//Un comment after CORS issue
		//this.getRecentBlocks()
		this.dayChange(this.selectedDayCount)
	},
	methods: {
		getRecentBlocks(){
			BlockAPI.getRecentBlocks()
				.then(data => {
					this.blockOptions.data=data
					this.blockOptions.loading=false
				})
				.catch(error => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						error,
						{ root: true }
					)
				})
		},
		dayChange(dayCount){
			if(dayCount){
				this.selectedDayCount=dayCount
				this.auditRequestSent(dayCount)
				this.auditRequestCompleted(dayCount)
				this.auditRequestAssessed(dayCount)
				this.auditRequestReceived(dayCount)
			}
		},
		auditRequestSent(dayCount) {
			AuditRequestsAPI.list({
				type: "outgoing",
				startDate: new Date(new Date().setDate(new Date().getDate() - dayCount)).getTime() ,
				endDate : new Date().getTime()
			})
				.then(result => {
					this.auditRequestsSent=result.total
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		auditRequestCompleted(dayCount) {
			AuditsAPI.list({
				type: "outgoing",
				startDate: new Date(new Date().setDate(new Date().getDate() - dayCount)).getTime() ,
				endDate : new Date().getTime()
			})
				.then(result => {
					this.auditRequestsCompleted=result.total
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		auditRequestAssessed(dayCount) {
			AuditsAPI.list({
				type: "incoming",
				notStatus: "0",
				startDate: new Date(new Date().setDate(new Date().getDate() - dayCount)).getTime() ,
				endDate : new Date().getTime()
			})
				.then(result => {
					this.auditRequestsAssessed=result.total
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
		auditRequestReceived(dayCount) {
			AuditRequestsAPI.list({
				type: "incoming",
				startDate: new Date(new Date().setDate(new Date().getDate() - dayCount)).getTime() ,
				endDate : new Date().getTime()
			})
				.then(result => {
					this.auditRequestsReceived=result.total
				})
				.catch(reason => {
					this.$store.dispatch(
						"loading/" + LoadingState.ACTION_SET_ERROR,
						reason,
						{ root: true }
					)
				})
		},
	}
}
</script>